import z from 'zod'

export const Permissions = {
    'roles.edit': 'Edit Roles',
    'users.view': 'View Users',
    'users.edit': 'Edit Users',
    'conjunctionalAgencies.view': 'View Conjunctional Agencies',
    'users.delete': 'Delete Users',
    'purchasers.view': 'View Purchasers',
    'purchasers.viewOthers': 'View Others Consultation Purchasers',
    'purchasers.edit': 'Edit My Purchasers',
    'purchasers.delete': 'Delete Purchasers',
    'purchasers.fullControl': 'Full Control of Purchasers',
    'agentStatement.view': 'View Agent Statements',
    'agentStatement.edit': 'Edit Agent Statements',
    'agentStatement.generatePayroll': 'Generate Payroll',
    'settings.view': 'View Settings',
    'settings.edit': 'Edit Settings',
    'todos.view': 'View Todos',
    'todos.manage': 'Manage Todos',
    'salesBoard.view': 'View Sales Board',
    'chat.manage': 'Manage Chat Groups',
    'links.view': 'View Links',
    'links.edit': 'Edit Links',
    'calendar.view': 'View Calendar',
    'calendar.edit': 'Edit Calendar',
    'groups.edit': 'Edit Chat Groups',
} as const

export type Permission = keyof typeof Permissions

export const PermissionsSchema = z.enum(Object.keys(Permissions) as [Permission, ...Permission[]]).array()

export const RoleSchema = z.object({
    roleName: z.string(),
    rolePermissions: PermissionsSchema,
})

export type RoleSchema = z.infer<typeof RoleSchema>
export type InternalRoleSchema = RoleSchema & {
    id: string
    orgId: string
}
